import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the itaIllustrationPage state domain
 */
const selectItaIllustrationPageDomain = state =>
  state.get('itaIllustrationPage', initialState);

/**
 * Other specific selectors
 */
const makeSelectLifeAssured = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('lifeAssured').toJS(),
  );

const makeSelectInitialLifeAssured = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('initialLifeAssured').toJS(),
  );

const makeSelectError = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('errorData').toJS(),
  );

const makeSelectConfig = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('itaConfig').toJS(),
  );

const makeSelectFiaCharge = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('fiaData').toJS(),
  );

const makeSelectProductConfig = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('productConfig').toJS(),
  );

const makeSelectQuoteId = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('quoteId'),
  );

const makeSelectApplicationId = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('applicationId'),
  );

const makeSelectBiPdf = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('benefitIllustrationPdf'),
  );

const makeSelectStatus = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('status'),
  );

const makeSelectReferenceNumber = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('referenceNumber'),
  );

const makeSelectCloneStatus = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('successClone'),
  );

const makeSelectemailSentStatus = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('emailSent'),
  );

const makeSelectEmailErrorMessage = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('emailErrorMessage'),
  );

const makeSelectCompletedDialog = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('completedDialog'),
  );

const makeSelectIsCalculateQuotePage = () =>
  createSelector(selectItaIllustrationPageDomain, substate =>
    substate.get('isCalculateQuotePage'),
  );

export {
  selectItaIllustrationPageDomain,
  makeSelectLifeAssured,
  makeSelectProductConfig,
  makeSelectFiaCharge,
  makeSelectConfig,
  makeSelectError,
  makeSelectQuoteId,
  makeSelectApplicationId,
  makeSelectBiPdf,
  makeSelectStatus,
  makeSelectReferenceNumber,
  makeSelectInitialLifeAssured,
  makeSelectCloneStatus,
  makeSelectemailSentStatus,
  makeSelectEmailErrorMessage,
  makeSelectCompletedDialog,
  makeSelectIsCalculateQuotePage,
};
